import { getCookie, setCookie, setCookieAt00, closeWinAt00 } from "./cookie";

const Cookie = {
  getCookie,
  setCookie,
  setCookieAt00,
  closeWinAt00
};

export default Cookie;
